$(function () {

	// PCヘッダー
	if ($('.mv').length) {

		var headHide = $('.mv').offset().top;
		var scrollStart = $('.gb-aria').offset().top;
		var distance = 0;

		$(document).scroll(function () {
			distance = $(this).scrollTop();

			if (headHide <= distance) {
				$('.header').addClass('-isHide');
			} else if (scrollStart >= distance) {
				$('.header').removeClass('-isHide');
			}

			if (scrollStart <= distance) {
				$('.header').addClass('-isLeaveIn').removeClass('-isHide');
			} else if (scrollStart >= distance) {
				$('.header').removeClass('-isLeaveIn');
			}


		});
	}

	$(function () {
		// #で始まるアンカーをクリックした場合に処理
		$('a[href^="#"]').click(function () {
			// 移動先を0px調整する。0を30にすると30px下にずらすことができる。
			var adjust = 0;
			// スクロールの速度
			var speed = 400; // ミリ秒
			// アンカーの値取得
			var href = $(this).attr("href");
			// 移動先を取得
			var target = $(href == "#" || href == "" ? 'html' : href);
			// 移動先を調整
			var position = target.offset().top + adjust;
			// スムーススクロール
			$('body,html').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	});

	//プラポリ書き換え
	if ($('#RowMessagePrivacyPolicy input[type=checkbox]').length) {
		$html = '';
		$html += '<span class="bs-mail-description">'
		$html += '<a href="/privacy-policy/" target="_blank">プライバシーポリシー</a>を送信前にご一読ください。';
		$html += '</span>';
		$('#RowMessagePrivacyPolicy .bs-mail-description').replaceWith($html);
	}

	//エラー文書き換え
	if ($('.form-error').length) {
		$('.form-error').each(function () {
			$inputName = $(this).attr('name');
			if ($inputName == 'name') {
				replaceText($(this), 'お名前をご入力ください。')
			} else if ($inputName == 'tel') {
				replaceText($(this), '電話番号を入力してください。')
			} else if ($inputName == 'e_mail') {
				replaceText($(this), 'メールアドレスをご入力ください。')
			} else if ($inputName == 'contents') {
				replaceText($(this), 'お問い合わせ内容をご入力ください。')
			} else if ($inputName == 'privacy_policy[]') {
				$errorMessage = $(this).closest('#RowMessagePrivacyPolicy').find('.error-message');
				$replaceHtml = '<div class="error-message">プライバシーポリシーをご一読の上、チェックを入れてください。</div>';
				$errorMessage.replaceWith($replaceHtml);
			}
		});
	}

	function replaceText($target, $text) {
		$errorMessage = $target.closest('td').find('.error-message');
		$replaceHtml = '<div class="error-message">' + $text + '</div>';
		$errorMessage.replaceWith($replaceHtml);
	}

});